import {
  ACQUIRER_NAME,
  CAP_IQ_ID,
  COMPANY_NAME_GPC,
  ENTERPRISE_VALUE,
  LTM_EBITDA,
  LTM_EBITDA_MARGIN,
  LTM_GROSS_MARGIN,
  LTM_REVENUE,
  LTM_REVENUE_GROWTH,
  SYMBOL_GPC,
  TARGET_NAME,
  TRANSACTION_DATE,
} from 'common/constants/comp-groups/compGroups';

const HEADER_CLASSNAME = 'table-header formatter-cell division-bottom-only';

export const GPC_HEADER_ROW = [
  {
    value: COMPANY_NAME_GPC,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: SYMBOL_GPC,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: CAP_IQ_ID,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
];

export const TRANSACTION_HEADER_ROW = [
  {
    value: TARGET_NAME,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: ACQUIRER_NAME,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: TRANSACTION_DATE,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: ENTERPRISE_VALUE,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: LTM_REVENUE,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: LTM_REVENUE_GROWTH,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: LTM_EBITDA,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: LTM_EBITDA_MARGIN,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  {
    value: LTM_GROSS_MARGIN,
    className: HEADER_CLASSNAME,
    readOnly: true,
  },
  // Commented this column because it's not used in the table for now. Probably we will need.
  // {
  //   value: CAP_IQ_ID,
  //   className: HEADER_CLASSNAME,
  //   readOnly: true,
  // },
];
